import moment from "moment";
import React, { useEffect, useState } from "react";
import { Modal, Button, InputGroup, Form } from "react-bootstrap";
import { Icon } from "@iconify/react";
import UploadImageComponent from "../UploadImageComponent";
import imgConfirmDelete from "../../assets/image-confirm-delete.png";
export default function PopUpConfirmDiscretion({
  open,
  onClose,
  onSubmit,
  title = "ແຈ້ງເຕືອນ!",
  sub = `ຈຳນວນເງິນດັ່ງກ່າວໄດ້ເກີນຂັ້ນຕ່ຳ ຫຼື ເກີນຂັ້ນສູງສຸດທີ່ທາງກອງທຶນ
  ເຮົາໄດ້ກຳນົດໄວ້, ເຊິ່ງຖ້າທ່ານຕ້ອງການຝາກຫຼຸດ ຫຼື ເກີນຈຳນວນນີ້, ທຸລະກຳດັ່ງກ່າວແມ່ນຜ່ານດຸນພິນິດຂອງຄະນະກຳມະການກອງທຶນບ້ານແລ້ວ ຍອມຮັບ ເພື່ອເປັນການເຮັດທຸລະກຳສຳເລັດ`,
}) {
  // state
  const [disabledConfirm, setDisabledConfirm] = useState(true);

  // useEffect
  useEffect(() => {
    setDisabledConfirm(true);
  }, [open]);

  return (
    <Modal show={open} onHide={onClose} size="sm">
      <Modal.Body
        style={{
          boxSizing: "border-box",
          overflow: "auto",
          width: "100%",
          padding: 20,
          paddingBottom: 0,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h1 style={{ color: "#343A40", fontSize: 20, fontWeight: 700 }}>
            {title}
          </h1>
          <p style={{ color: "#6C757D", fontSize: 14 }}>{sub}</p>
        </div>
        <div>
          <Form.Control
            placeholder="ຍອມຮັບ"
            onChange={(e) => {
              if (e.target.value === "ຍອມຮັບ") {
                setDisabledConfirm(false);
              } else {
                setDisabledConfirm(true);
              }
            }}
          />
          <Form.Label style={{fontSize: 12}}>ກະລຸນາພິມ <span style={{color: "#0078C1"}}>"ຍອມຮັບ"</span>, ຖ້າຕ້ອງການດຳເນີນລາຍການນີ້</Form.Label>
        </div>
      </Modal.Body>
      <Modal.Footer style={{ marginBottom: 20 }}>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            gap: 10,
          }}
        >
          <Button
            variant="outline-primary"
            size="md"
            style={{ minWidth: 120 }}
            onClick={onClose}
          >
            ຍົກເລີກ
          </Button>
          <Button
            variant="primary"
            size="md"
            style={{ minWidth: 120 }}
            onClick={() => {
              onSubmit();
              setDisabledConfirm(true);
            }}
            disabled={disabledConfirm}
          >
            ຍອມຮັບ
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
